// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".million-billion-text-clickable {\n    color: var(--generalTextColor);\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
